import React from 'react'
import Button from '@react/react-spectrum/Button'
import ChevronLeft from '@react/react-spectrum/Icon/ChevronLeft'
import ChevronRight from '@react/react-spectrum/Icon/ChevronRight'

const Pagination = ({ page, setPage, totalItems, itemsPerPage, view }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage)
  if (totalPages === 1) return null
  return (
    <div className={`projects__pagination ${view === 'cards' ? 'grid-view' : ''}`}>
      <Button
        disabled={page === 1}
        variant='action'
        quiet
        aria-label='Previous'
        icon={<ChevronLeft />}
        onClick={() => setPage(page - 1)}
      />
      <span>
        {page} of {totalPages} Pages
      </span>
      <Button
        disabled={page * itemsPerPage >= totalItems}
        variant='action'
        quiet
        aria-label='Next'
        icon={<ChevronRight />}
        onClick={() => setPage(page + 1)}
      />
    </div>
  )
}

export default Pagination
